// extracted by mini-css-extract-plugin
module.exports = {"notificationWrap":"Notification_notificationWrap__1tLCG","iconWrap":"Notification_iconWrap__3b8_m","message":"Notification_message__GoarU"};